import { render } from "./ModalPageTerminos.vue?vue&type=template&id=202b7eb6"
import script from "./ModalPageTerminos.vue?vue&type=script&lang=js"
export * from "./ModalPageTerminos.vue?vue&type=script&lang=js"

import exportComponent from "/home/kira/codemark/zonadigital/frond/deploy/zona-digital-ecommerce-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__